import React, { useState } from "react";
import "../styles/UserQueries.css";

const UserQueries = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // ⭐ Justivon Legal Platform FAQ List
  const faqList = [
    // Appointments & Booking
    {
      question: "How do I book an appointment with a solicitor?",
      answer:
        "You can search for solicitors using location and practice area, view their profile, and click on the “Book Appointment” button to schedule a consultation online.",
    },
    {
      question: "Can I book an appointment for a future date?",
      answer:
        "Yes, you can book appointments only for future available time slots. Past time slots are disabled for booking.",
    },
    {
      question: "Is there a minimum notice period for booking?",
      answer:
        "Yes, appointments can be booked only if the time slot is at least 3 hours after the current time.",
    },
    {
      question: "Can I cancel or reschedule my appointment?",
      answer:
        "Yes, you can cancel or reschedule your appointment from your dashboard before the scheduled consultation time.",
    },

    // Solicitors & Profiles
    {
      question: "How are solicitors verified on Justivon?",
      answer:
        "All solicitors go through a verification process where their identity, credentials, and practice details are reviewed by the Justivon admin team.",
    },
    {
      question: "Can I view a solicitor’s experience and practice areas?",
      answer:
        "Yes, each solicitor profile displays their experience, advocate level, courts practiced, and detailed practice areas.",
    },
    {
      question: "What does ‘Verified Solicitor’ mean?",
      answer:
        "A Verified Solicitor has been reviewed and approved by Justivon, ensuring their credentials are authentic and active.",
    },

    // Payments & Consultation
    {
      question: "Do I need to pay to book an appointment?",
      answer:
        "Payment requirements depend on the solicitor. Some consultations may be free, while others require payment before confirmation.",
    },
    {
      question: "What payment methods are supported?",
      answer:
        "We support UPI, credit/debit cards, net banking, and other secure online payment methods.",
    },
    {
      question: "Is online payment safe on Justivon?",
      answer:
        "Yes, all payments are processed through secure and encrypted payment gateways to protect your data.",
    },

    // My Account & Dashboard
    {
      question: "Do I need an account to use Justivon?",
      answer:
        "Yes, creating an account is required to book appointments, manage cases, and track your consultations.",
    },
    {
      question: "How can I view my appointment history?",
      answer:
        "Log in to your dashboard and go to the Appointments section to see your past and upcoming consultations.",
    },
    {
      question: "How can I update my profile details?",
      answer:
        "You can update your personal information from the Profile section in your dashboard.",
    },

    // Cases & Legal Services
    {
      question: "Can I manage my legal cases online?",
      answer:
        "Yes, Justivon provides a case management system where you can view case status, hearing dates, and updates in calendar mode.",
    },
    {
      question: "Will I receive notifications for hearings and updates?",
      answer:
        "Yes, you will receive email notifications and dashboard alerts for important case and hearing updates.",
    },

    // Security & Privacy
    {
      question: "How is my personal data protected?",
      answer:
        "We use industry-standard security practices to encrypt and protect your personal and legal information.",
    },
    {
      question: "Is my consultation information confidential?",
      answer:
        "Yes, all consultations and messages are treated as strictly confidential and are visible only to you and your solicitor.",
    }
  ];

  const toggleFaq = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="userQueries-container">
      <h2 className="userQueries-title">Frequently Asked Questions</h2>

      {faqList.map((faq, index) => (
        <div
          key={index}
          className={`userQueries-faqItem ${
            activeIndex === index ? "active" : ""
          }`}
        >
          <div 
            className="userQueries-question" 
            onClick={() => toggleFaq(index)}
          >
            <span>{faq.question}</span>
            <span className="userQueries-arrow">
              {activeIndex === index ? "▲" : "▼"}
            </span>
          </div>
          
          <div
            className={`userQueries-answer ${
              activeIndex === index ? "active" : ""
            }`}
          >
            {faq.answer}
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserQueries;
